import { render, staticRenderFns } from "./payType.vue?vue&type=template&id=ec998b3c&scoped=true&"
import script from "./payType.vue?vue&type=script&lang=js&"
export * from "./payType.vue?vue&type=script&lang=js&"
import style0 from "./payType.vue?vue&type=style&index=0&id=ec998b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec998b3c",
  null
  
)

export default component.exports